<script>
import options from "./RelatedProductCourse.options";
export default options;
</script>

<template>
    <article class="nti-related-product-course">
        <h5 class="nti-related-product-course__container-title" v-if="data">{{ verifyLabel('relatedCourseBannerSectionTitle') }}</h5>
        <template v-for="card in data" :key="card.id">
            <a :href="card.link">
                <article  class="nti-related-product-course__card">
                    <div class="nti-related-product-course__image-container">
                        <img :src="card.imageUrl" alt="product image">
                    </div>

                    <div class="nti-related-product-course__card__left-container">
                        <h3 class="nti-related-product-course__card__title">{{ card.header }}</h3>
                        <p class="nti-related-product-course__card__text">{{ card.title }}</p>
                        <h3 v-if="card.priceText" class="nti-related-product-course__card__price">
                            <span class="nti-related-product-course__card__small-font">
                                {{ verifyLabel('fromPriceLabel') }}
                            </span>
                            {{ card.priceText }}
                        </h3>
                    </div>
                    <div class="nti-related-product-course__card__right-container">
                        <button class="nti-button nti-button--related-product-course">{{ card.buttonText }}</button>
                    </div>
                </article>
            </a>
        </template>
    </article>
</template>

